export const text = [
    {
        summary: 'Feel the tension',
        details: [
            {
                summary: 'Too much from one side',
                details: [
                    {
                        summary: 'They collide(d) eventually',
                        details: [
                            {
                                summary: 'Much too soon',
                                details: [
                                    "Because now it's all a big mess."
                                ],
                            },
                        ],
                    },
                ],
            },
            {
                summary: 'Too little from the other',
                details: [
                    {
                        summary: 'They intersect(ed) eventually',
                        details: [
                            {
                                summary: 'Much too fast',
                                details: [
                                    "And it's too far gone."
                                ],
                            },
                        ],
                    },
                ],
            },
        ]
    }
];

export default text;